export default {
  receipt_link:require("assets/icons/reciept_1.png").default,
  invoice_link:require("assets/icons/invoice_1.png").default,
  edit_icon:require("assets/icons/edit_prescription.png").default,
clear_all:require("assets/icons/clear_all.png").default,
thumbs_up:require("assets/icons/thumbs-up.png").default,
thumbs_down:require("assets/icons/thumb-down.png").default,
  //receipt_link:require("assets/icons/rec_dark_png.png").default,
  care_ticket: require("assets/img/careteam_sidemenu_ticket.png").default,
  dashboard: require("assets/img/sidemenu_dashboard.svg").default,
  assessment: require("assets/img/sidemenu_assessment.svg").default,
  doctor_comments: require("assets/img/doctor_comments.svg").default,
  appointment: require("assets/img/sidemenu_appointment.svg").default,
  consultation_history: require("assets/img/sidemenu_consultation_history.svg")
    .default,
  phi_profile: require("assets/img/sidemenu_phi_profile.svg").default,
  patient_record: require("assets/img/careteam_sidemenu_patient_records.png")
    .default,
  patient_profile: require("assets/icons/Icon-subscription-end -date-new.svg").default,
  patient_profile_plan: require("assets/icons/Icon-current-subscription-plan -new.svg").default,
  my_patients: require("assets/img/sidemenu_doctor_my_patient.png").default,
  doctor_availability: require("assets/img/sidemenu_doctor_my_availability.svg")
    .default,
  star: require("assets/img/star.png").default,
  next: require("assets/img/next.png").default,
  facebook: require("assets/img/facebook_logo.png").default,
  instagram: require("assets/img/insta_logo.png").default,
  twitter: require("assets/img/twitter_logo.png").default,
  youtube: require("assets/img/youtube_logo.png").default,
  down_arrow: require("assets/img/careteam_my_tickets_down_arrow@2x.png").default,
  triangle: require("assets/img/completion_placeholder@2x.png").default,
  prescription: require("assets/img/my_patient_prescription.png").default,
  prescription: require("assets/img/my_patient_prescription.png").default,
  casesheet: require("assets/img/my_patient_casesheet.png").default,
  my_patient_assessment: require("assets/img/my_patient_assessment.png").default,
  my_patient_phi: require("assets/img/my_patient_phi_profile.png").default,
  prescription: require("assets/img/my_patient_prescription.png").default,
  casesheet: require("assets/img/my_patient_casesheet.png").default,
  assessment_large: require("assets/img/assessment_large.png").default,
  my_patient_phi: require("assets/img/my_patient_phi_profile.png").default,
  patient_consultaion: require("assets/img/patient_consultation.png").default,
  search: require("assets/img/search.png").default,
  delete: require("assets/img/bin.png").default,
  phi_db: require("assets/img/phi.png").default,
  hospital_visit: require("assets/img/hospital_black.svg").default,
  video_cam: require("assets/img/videocam_black.svg").default,
  hospital_visit_bg: require("assets/img/hospital.svg").default,
  video_cam_bg: require("assets/img/videocam.svg").default,
  video: require("assets/img/video_teal.svg").default,
  video_preview: require("assets/img/video_preview.png").default,
  next: require("assets/img/next.png").default,
  previous: require("assets/img/previous.png").default,
  next_double: require("assets/img/next_double.png").default,
  previous_double: require("assets/img/previous_double.png").default,
  next_arrow: require("assets/img/docdb_arrow1.png").default,
  niyama_logo: require("assets/icons/new_niyama_logo.svg").default,
  niyama_logo_new: require("assets/icons/new_niyama_logo.svg").default,
  niyama_n_logo: require("assets/icons/niyama-n-logo.svg").default,
  arrow_icon: require("assets/img/view_all.png").default,
  stop_icon: require("assets/img/stop.png").default,
  // doctor_icon: require("assets/img/myapp.png").default,
  patient_icon: require("assets/img/my_patient.png").default,
  appointment_icon: require("assets/img/my_aval.png").default,
  consult_icon: require("assets/img/my_consult.png").default,
  score_icon: require("assets/img/score.png").default,
  card_icon: require("assets/img/card_bg.png").default,
  upcoming_icon: require("assets/img/upcoming_logo.png").default,
  my_aval_icon: require("assets/img/my_aval.png").default,
  doc_aval_icon: require("assets/img/doc_ava.png").default,
  arrow_without_bg: require("assets/img/arrow_without_bg.png").default,
  plus_icon: require("assets/img/img_phi_upload_document.png").default,
  edit_icon: require("assets/img/schedule_appointment_edit.svg").default,
  new_edit_icon_prescription: require("assets/img/icon-edit-gray.svg").default,
  book_appointment_person: require("assets/img/img_schedule_appointment_person.png").default,
  reload: require("assets/img/reload.png").default,
  information: require("assets/img/information.png").default,
  star: require("assets/img/star.png").default,
  tickets: require("assets/img/careteam_sidemenu_ticket.png").default,
  ticket: require("assets/img/careteam_sidemenu_ticket.svg").default,
  patient_records: require("assets/img/careteam_sidemenu_patient_records.svg").default,
  subscription_crown: require("assets/img/subscription_payment_login_member.svg").default,
  membership_display_icon: require('assets/icons/icon-menu-membership-default.svg').default,
  print: require("assets/img/printer.png").default,
  assessment_no_data: require("assets/img/img_assessment_history_empty.png").default,
  assessment_score: require("assets/img/assessment_score.png").default,
  calender_icon: require("assets/icons/Icon-date-new.svg").default,
  doctor_icon: require("assets/icons/Icon-doctor_referral-new.svg").default,
  mobile_icon: require("assets/img/careteam_my_tickets_mobile.png").default,
  language_icon: require("assets/img/careteam_my_tickets_language.svg").default,
  instruction_icon: require("assets/img/careteam_my_tickets_instruction.svg").default,
  prescription_generated_icon: require("assets/img/careteam_my_tickets_prescription_generated.svg").default,
  subscription_icon: require("assets/img/careteam_my_tickets_subscription.png").default,
  clock_icon: require("assets/icons/Icon-time-new.svg").default,
  patient_icon: require("assets/img/careteam_my_tickets_patient.png").default,
  patient_health_information_icon: require("assets/icons/sidemenu_patient_phi_profile.svg").default,
  patient_list_icon: require("assets/icons/sidemenu_patient_list.svg").default,
  dashboard_doctor_icon: require("assets/img/doctor_dashboard_my_patient.svg").default,
  dashboard_video_icon: require("assets/img/doctor_dashboard_my_consultation.svg").default,
  home_how_niyama_works: require("assets/img/home_how_niyama.png").default,
  tick_icon: require("assets/img/logged_user_dashboard_tick.png").default,
  plan_icon: require("assets/icons/Group.svg").default,
  large_tick_icon:require("assets/img/large_tick.png").default,
  niyama_icon_white: require("assets/icons/niyama_logo_white_text.svg").default,
  sign_in_icon: require("assets/img/img_signing_illustration.png").default,
  preview_image: require("assets/img/preview_image.png").default,
  preview_upload: require("assets/img/preview-upload.png").default,
  appointment_doctor: require("assets/img/careteam_patient_records_doctor.svg").default,
  appointment_calender: require("assets/img/careteam_patient_records_calender.svg").default,
  appointment_clock: require("assets/img/careteam_patient_records_clock.svg").default,
  subscribed_user_dashboard: require("assets/img/subscribed_user_dashboard_schedule_appointment.svg").default,
  slot_confirm_icon:require("assets/img/slot-confirm-icon.svg").default,
  save_icon: require("assets/img/floppy-disk.png").default,
  therapy_values: require("assets/img/TherapyValues.png").default,
  chat: require("assets/img/chatIcon.svg").default,
  coupon: require("assets/img/discount.png").default,
  whatsapp: require("assets/img/whatsapp_logo.png").default,
  new_assessment: require("assets/icons/icon-assessment.svg").default,
  new_health_information: require("assets/icons/icon-health-info.svg").default,
  new_casenotes: require("assets/icons/icon-casenotes.svg").default,
  new_prescription: require("assets/icons/icon-prescription.svg").default,
  new_add_prescription: require("assets/icons/add_prescription.svg").default,
  new_dsm: require("assets/icons/icon-dsm.svg").default,
  new_mse: require("assets/icons/icon-mse.svg").default,
  new_psy: require("assets/icons/icon-psy.svg").default,
  new_add_casenotes: require("assets/icons/add_casenotes.svg").default,
  new_dashboard_arrow_circle: require("assets/icons/dash_arrow_circle_small.svg").default,
  new_dashboard_exclamation: require("assets/icons/dashboard_exclamation.svg").default,
  new_dashboard_error_exclamation_circle: require("assets/icons/dashboard_error_exclamation_circle.svg").default,
  new_dash_tick_circle: require("assets/icons/dash_tick_circle_teal.svg").default,
  new_dashboard_user_circle: require("assets/icons/dashboard_user_circle.svg").default,
  new_patient_health_information: require("assets/icons/menu_health.svg").default,
  new_patient_my_appointments: require("assets/icons/menu_card_appointment.svg").default,
  new_patient_my_consultations: require("assets/icons/menu_consultation.svg").default,
  new_patient_niyama_care: require("assets/icons/dash_niyama_care.svg").default,
  new_patient_self_assessment: require("assets/icons/menu_card_assessment.svg").default,
  new_dashboard_book_appointment: require("assets/icons/dash_book_appointment.svg").default,
  patient_treatment_plan: require("assets/icons/icon-treatment-plan.svg").default,
  patient_diagnosis_plan: require("assets/icons/icon-diagnosis.svg").default,
  new_corporate_admin_upload: require("assets/icons/corporate_admin_upload.svg").default,
  new_corporate_admin_members: require("assets/icons/corporate_admin_members.svg").default,
  new_corporate_admin_dashboard: require("assets/icons/corporate_admin_dashboard.svg").default,
  new_plan_arrow_circle : require("assets/icons/dash_arrow_circle_big.svg").default,
  new_dash_take_assessment: require("assets/icons/dash_take_assessment.svg").default,
  new_video_consultation_service: require("assets/icons/24_hours_support.svg").default,
  save_btn_icon:require("assets/icons/save-icon.svg").default,
  membership_icon:require("assets/icons/membership_icon.png").default,
  new_icon_dashboard_fill :require("assets/icons/new-icon-dashboard-fill.svg").default,
  new_icon_dashboard :require("assets/icons/new-icon-dashboard.svg").default,
  new_icon_appointment :require("assets/icons/new-icon-appointment.svg").default,
  new_icon_appointment_fill :require("assets/icons/new-icon-appointment-fill.svg").default,
  new_icon_assessment :require("assets/icons/new-icon-assessment.svg").default,
  new_icon_assessment_fill :require("assets/icons/new-icon-assessment-fill.svg").default,
  new_icon_health_info :require("assets/icons/new-icon-health-info.svg").default,
  new_icon_health_info_fill :require("assets/icons/new-icon-health-info-fill.svg").default,
  new_icon_my_profile :require("assets/icons/new-icon-my-profile.svg").default,
  new_icon_my_profile_fill :require("assets/icons/new-icon-my-profile-fill.svg").default,
  new_icon_subscription :require("assets/icons/new-icon-subscription.svg").default,
  new_icon_subscription_fill :require("assets/icons/new-icon-subscription-fill.svg").default,
  save_icon:require("assets/icons/save-icon-teal.svg").default,
  settings_icon:require("assets/icons/settings-icon.svg").default,
  membership_icon:require("assets/icons/membership_icon.png").default,
  close_icon:require("assets/img/profile_delete@2x.png").default,
  protective_factor:require("assets/icons/icon-protective-factor.svg").default,
  sos:require("assets/icons/icon-sos.svg").default,
  dots:require("assets/icons/icon-dots.svg").default,
  view:require("assets/icons/icon-consultation-history.svg").default,
  view_care_admin:require("assets/icons/view-care-admin.svg").default,
  care_admin_resolve:require("assets/icons/icon-resolve-ticket.svg").default,
  care_admin_view_appointment:require("assets/icons/icon-care-admin-patient-consultations-new.svg").default,
  care_admin_view_profile:require("assets/icons/icon-care-admin-patient-profiles-new.svg").default,
  care_admin_view_plan_history:require("assets/icons/icon-care-admin-patient-plan-history-new.svg").default,
  view_in_progress_care_admin:require("assets/icons/view-in-progress.svg").default,
  profile_care_admin:require("assets/icons/CA_profile.svg").default,
  transcript_icon:require("assets/icons/icon-transcript.svg").default,
  corporate_avatar:require("assets/icons/corporate-avatar.svg").default,
  icon_chat:require("assets/icons/new_icon_chat.svg").default,
  faq_bot_icon:require("assets/icons/bot_icon.svg").default,
  appointment_delete_icon:require("assets/icons/delete-icon.svg").default,
  appointment_edit_icon:require("assets/icons/edit-icon.svg").default,
  upload_doc_dark:require("assets/icons/upload-dark.svg").default,
  upload_doc_light:require("assets/icons/upload-light.svg").default,
  appointment_doctor_icon:require("assets/icons/icon-doctor.svg").default,
  appointment_time_icon:require("assets/icons/icon-appointment-time.svg").default,
  appointment_cancel_dark_icon:require("assets/icons/icon-cancel-dark.svg").default,
  appointment_cancel_light_icon:require("assets/icons/icon-cancel-light.svg").default,
  appointment_reschedule_dark_icon:require("assets/icons/icon-reschedule-dark.svg").default,
  appointment_reschedule_light_icon:require("assets/icons/icon-reschedule-light.svg").default,
  right_arrow_dashboard:require("assets/icons/icon-right-arrow-dark-gray.svg").default,
  instruction:require("assets/img/img-info-gray.png").default,
  careadmin_patient_name:require("assets/icons/Icon-patient-name-new.svg").default, 
  doctor_availability_icon:require("assets/icons/icon-doctor-availability-sider.svg").default, 
  plan_active:require("assets/icons/plan-active.svg").default,
  plan_expired:require("assets/icons/plan-expired.svg").default,
  transcription_video_icon:require("assets/icons/icon-video-consult.svg").default,
  transcription_video_white_icon:require("assets/icons/icon-video-consult_white.svg").default,
  transcription_chat_white_icon:require("assets/icons/icon-video-transcript_white.svg").default,
  transcription_chat_icon:require("assets/icons/icon-video-transcript_teal.svg").default,
  check_circle:require("assets/icons/check_circle.svg").default,
  mail_icon:require("assets/icons/mail_icon.svg").default,
  telephone:require("assets/icons/telephone.svg").default,
  star_insurence:require("assets/icons/star_health.svg").default,
  info_blue:require("assets/icons/icon_info.svg").default,
  warning_orange:require("assets/icons/icon_warning.svg").default,
  filled_tick_icon:require("assets/icons/filled-tick-icon.svg").default,
  process_timer_icon:require("assets/icons/process-timer.svg").default,
  back_btn_icon:require("assets/icons/chevron_right.svg").default,
  hours_24_disable:require("assets/icons/24-hours.svg").default,
  hours_24_active:require("assets/icons/24-hours-active.svg").default,
  icon_doctor_avatar:require("assets/icons/icon-doctor-avatar.svg").default,
  icon_doctor_avatar:require("assets/icons/icon-doctor-avatar.svg").default,
  prescription_icon:require("assets/icons/prescription-icon.svg").default,
  feedback_icon:require("assets/icons/feedback-icon.svg").default,
  assessment_header:require("assets/icons/Assessment_header.svg").default,
  pie_chart_header:require("assets/icons/pie-chart_header.svg").default,
  schedule_appointment_header: require("assets/icons/schedule_appointment_header.svg").default,
  subscription_header: require("assets/icons/subscription_header.svg").default,
  health_info_header: require("assets/icons/health_information_header.svg").default,
  my_orders_header: require("assets/icons/My_orders_header.svg").default,
  my_profile_header: require("assets/icons/my_profile_header.svg").default,
  assessment_arrow_icon: require("assets/icons/dashboard_arrow_circle.svg").default,
  assessment_list_icon: require("assets/icons/icon-begin-assessment.svg").default,
  assessment_completed_icon: require("assets/icons/completed-img.png").default,
  live_chat:require("assets/icons/live_chat.svg").default,
  thumbs_up_gray:require("assets/icons/Like_Unselected.svg").default,
  thumbs_up_green:require("assets/icons/Like_Selected.svg").default,
  thumbs_down_gray:require("assets/icons/Dislike_Unselected.svg").default,
  thumbs_down_red:require("assets/icons/Dislike_Selected.svg").default,
  green_round_icon_one:require("assets/icons/icon-1-green-round.svg").default,
  green_round_icon_two:require("assets/icons/icon-2-green-round.svg").default,
  green_round_icon_three:require("assets/icons/icon-3-green-round.svg").default,
  green_round_icon_four:require("assets/icons/icon-4-green-round.svg").default,
  assessment_header:require("assets/icons/Assessment_header.svg").default,
  pie_chart_header:require("assets/icons/pie-chart_header.svg").default,
  schedule_appointment_header: require("assets/icons/schedule_appointment_header.svg").default,
  subscription_header: require("assets/icons/subscription_header.svg").default,
  health_info_header: require("assets/icons/health_information_header.svg").default,
  my_orders_header: require("assets/icons/My_orders_header.svg").default,
  my_profile_header: require("assets/icons/my_profile_header.svg").default,
  document_upload_header: require("assets/icons/document-upload-header.svg").default,
  switch_account_header: require("assets/icons/switch-account-header.svg").default,
  login_signup_img: require("assets/icons/login-signup-image.png").default,
  adult_logo:require("assets/icons/img-adult.svg").default,
  adolescent_logo:require("assets/icons/img-adolescent.svg").default,
  senior_logo:require("assets/icons/img-senior-adult.svg").default,
  checked_logo:require("assets/icons/img-checked.svg").default,
  unchecked_logo:require("assets/icons/img-uncheck.svg").default,
  select_assessment:require("assets/icons/icon-begin-assessment-new.svg").default,
  download_logo:require("assets/icons/img_download.svg").default,
  success_logo:require("assets/icons/img_success.svg").default,
  cancel_logo:require("assets/icons/img_cancel.svg").default,
  pending_logo:require("assets/icons/img_hourglass.svg").default,
  terminated_logo:require("assets/icons/img_stop.svg").default,
  in_progress_logo:require("assets/icons/img_bars.svg").default,
  renewed_logo:require("assets/icons/img_frame.svg").default,
  red_dot:require("assets/icons/Red_Dot.svg").default,
  green_dot:require("assets/icons/Green_Dot.svg").default,
  empty:require("assets/icons/icon-empty.svg").default,
  circle_checked: require("assets/icons/circle-checked.svg").default,
  circle_unchecked: require("assets/icons/circle-uncheck.svg").default,
  multi_role_doctor: require("assets/icons/doctor_man.svg").default,
  multi_role_care_admin: require("assets/icons/careadmin_girl.svg").default,
  multi_role_spoc: require("assets/icons/spoc_man.svg").default,
  multi_role_patient: require("assets/icons/patient_man.svg").default,
  login_signup_img: require("assets/icons/login-signup-image.png").default,
  adolescent_card:require("assets/icons/adolescent.png").default,
  adult_card:require("assets/icons/adult.png").default,
  senior_adult_card:require("assets/icons/senior_adult.png").default,
  dot:require("assets/icons/dot.svg").default,
  confirm_green_tick_icon:require("assets/icons/conformation-green-tick-icon.svg").default,
  cancelled_red_cross_icon:require("assets/icons/cancelled-red-cross-icon.svg").default,
  report_attachment_icon: require("assets/icons/attachment-icon.svg").default,
  logout_icon: require("assets/icons/logout-icon.svg").default,
  careadmin_patient_icon: require("assets/icons/careadmin_patient_icon.svg").default,
  careadmin_doc_icon: require("assets/icons/careadmin_doctor_icon.svg").default,
  empty_folder_icon: require("assets/img/folder.png").default,  
  action_dots:require("assets/icons/actions_dots.svg").default,
  search_all_patients: require("assets/icons/search-all-patients.svg").default,
  allPatients_arrow_icon: require("assets/icons/allpatients_arrow_icon.svg").default,
  multi_role_super_admin: require("assets/icons/spoc_man.svg").default,
}